import {
  PlatformAdmin,
  SiteAdmin,
  HubAdmin,
  ProjectAdmin,
} from 'lib/authorization/Roles'
import type { PageType } from 'types/Page'

export const pagePrivileges: PageType[] = [
  {
    name: 'participants',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin],
    featureToggles: [],
  },
  {
    name: 'projects',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin, ProjectAdmin],
    featureToggles: [],
  },
  {
    name: 'newsletters',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin],
    featureToggles: [],
  },
  {
    name: 'hubs',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin],
    featureToggles: ['self_service_hubs', 'hubs_on_new_appearance_editor'],
  },
  {
    name: 'team',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin],
    featureToggles: [],
  },
  {
    name: 'text_analysis_v2',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin, ProjectAdmin],
    featureToggles: ['text_analysis_v2'],
  },
  {
    name: 'show_custom_dashboard',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin, ProjectAdmin],
    featureToggles: ['show_custom_dashboard'],
  },
  {
    name: 'submission_manager',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin, ProjectAdmin],
    featureToggles: ['submission_manager'],
  },
  {
    name: 'appearance',
    allowedRoles: [PlatformAdmin, SiteAdmin],
    featureToggles: ['show_new_home_page_editor'],
  },
  {
    name: 'tag manager',
    allowedRoles: [PlatformAdmin, SiteAdmin],
    featureToggles: [],
  },
  {
    name: 'hubpage manager',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin],
    featureToggles: ['self_service_hubs'],
  },
  {
    name: 'text_analysis_v2',
    allowedRoles: [PlatformAdmin, SiteAdmin],
    featureToggles: [],
  },

  {
    name: 'show_custom_dashboard',
    allowedRoles: [PlatformAdmin, SiteAdmin],
    featureToggles: [],
  },
  {
    name: 'submission_manager',
    allowedRoles: [PlatformAdmin, SiteAdmin],
    featureToggles: [],
  },
  {
    name: 'dashboard',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin, ProjectAdmin],
    featureToggles: [],
  },
  {
    name: 'reporting_dashboard_v2',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin, ProjectAdmin],
    featureToggles: ['reporting_dashboard_v2'],
  },
  {
    name: 'multilingual_admin_interface',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin, ProjectAdmin],
    featureToggles: ['multilingual_admin_interface'],
  },
  {
    name: 'site_settings',
    allowedRoles: [PlatformAdmin, SiteAdmin],
    featureToggles: [],
  },
  {
    name: 'static-pages',
    allowedRoles: [PlatformAdmin, SiteAdmin],
    featureToggles: [],
  },
  {
    name: 'enable_reporting_filter_builder',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin, ProjectAdmin],
    featureToggles: ['enable_reporting_filter_builder'],
  },
  {
    name: 'enable_participant_page_hub_filters',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin, ProjectAdmin],
    featureToggles: ['enable_participant_page_hub_filters'],
  },
  {
    name: 'location_question',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin, ProjectAdmin],
    featureToggles: ['location_question'],
  },
  {
    name: 'age_question',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin, ProjectAdmin],
    featureToggles: ['age_question'],
  },
  {
    name: 'modelled_data_ethnicity_field',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin, ProjectAdmin],
    featureToggles: ['modelled_data_ethnicity_field'],
  },
  {
    name: 'modelled_data_gender_field',
    allowedRoles: [PlatformAdmin, SiteAdmin, HubAdmin, ProjectAdmin],
    featureToggles: ['modelled_data_gender_field'],
  },
]
